import Constants from "./Constants";

 const endpoints = {
  LOGIN_USER: Constants.BASE_API_URL + "admin/login",
  MASTER_ORG_REGISTER: Constants.BASE_API_URL + "master-org/register",
  MASTER_ORG_UPLOAD: Constants.BASE_API_URL + "master-org/upload",
  MASTER_ORG_CONNECT: Constants.BASE_API_URL + "master-org/connect",
  ADMIN_PROFILE_GET: Constants.BASE_API_URL + "admin/profile/get",
  ADMIN_PROFILE_UPDATE: Constants.BASE_API_URL + "admin/profile/update",
  FORGOT_PASSWORD: Constants.BASE_API_URL + "admin/forgotpassword",
  VERIFICATIONCODE_ORGANIZATION: Constants.BASE_API_URL + "organisation/verify/code",
  RESEND_CODE: Constants.BASE_API_URL + "admin/resend/code",
  RESET_PASSWORD: Constants.BASE_API_URL + "organisation/resetpassword",
  CREATE_PASSWORD: Constants.BASE_API_URL + "admin/createpassword",
  ACTIVE_DEACTIVE_USER: Constants.BASE_API_URL + "admin/user/statusupdate",
  USER_TOTEL_DATA: Constants.BASE_API_URL + "admin/user/total/count",
  ADMIN_USER_LIST: Constants.BASE_API_URL + "admin/user/list",
  ADMIN_ANALYTICS_DASHBOARD: Constants.BASE_API_URL + "admin/analytics/dashboard",
  FIXTURE_REPORT: Constants.BASE_API_URL + "admin/fixture/report/list",
  UMPHIRE_REPORT: Constants.BASE_API_URL + "admin/umphire/report/list",
  SUBADMIN_ADD: Constants.BASE_API_URL + "admin/subadmin/add",
  USER_PROFILE: Constants.BASE_API_URL + "umphire/view/profile",
  GUIDELINES_PAGE: Constants.BASE_API_URL + "admin/guildline/",
  UPDATE_ADD: Constants.BASE_API_URL + "admin/guidline/add",
  SPORT_LIST_COMMON: Constants.BASE_API_URL + "user/sport/list",
  // verifier
  VERIFIER_PROFILE: Constants.BASE_API_URL + "verifier/profile/view",
  //scholls 
  ORG_PROFILE: Constants.BASE_API_URL + "organisation/profile/view",
  UMPHIRE_DELETE: Constants.BASE_API_URL + "admin/umphire/delete",
  FIXTURE_DELETE: Constants.BASE_API_URL + "organisation/fixture/delete",
  SESSION_LIST: Constants.BASE_API_URL + "admin/user/alllist",
  JOBS_LIST: Constants.BASE_API_URL + "admin/user/alllist",
  //advertisement
  ADVERTISEMENT_VIEW : Constants.BASE_API_URL + "admin/advertisement/view" ,
  ADVERTISEMENT_LIST : Constants.BASE_API_URL + "admin/advertisement/list" ,
  ADD_ADVERTISEMENT : Constants.BASE_API_URL + "admin/advertisement/add" ,
  EDIT_ADVERTISEMENT : Constants.BASE_API_URL + "admin/advertisement/edit" ,
  DELETE_ADVERTISEMENT : Constants.BASE_API_URL + "admin/advertisement/delete" ,
  ADVERTISEMENT_REORDER : Constants.BASE_API_URL + "admin/advertisement/reorder" ,
  ADVERTISEMENT_ORGS : Constants.BASE_API_URL + "admin/advertisement/orgs" ,
  ROLES_LIST : Constants.BASE_API_URL + "user/roles" ,

  // doc
  UPDATE_DOC:Constants.BASE_API_URL + "umphire/document/verify",

  // // INTEREST
  // INTEREST_LIST: Constants.BASE_API_URL + "admin/interest/list",
  // DELETE_INTEREST: Constants.BASE_API_URL + "admin/interest/delete",
  // EDIT_INTEREST: Constants.BASE_API_URL + "admin/interest/edit",
  // ADD_INTEREST: Constants.BASE_API_URL + "admin/interest/add",
  // VIEW_INTEREST: Constants.BASE_API_URL + "admin/interest/view",
  // DELETE_CATEGORY_INTEREST:
  //   Constants.BASE_API_URL + "admin/interest/category/delete",
  // ADD_CATEGORY_INTEREST: Constants.BASE_API_URL + "admin/interest/category/add",

  // VOLUNTEERS_LIST: Constants.BASE_API_URL + "admin/volunteer/list",
  // ADD_VOLUNTEER: Constants.BASE_API_URL + "admin/volunteer/add",
  // DELETE_VOLUNTEER: Constants.BASE_API_URL + "admin/volunteer/delete",
  // EDIT_VOLUNTEER: Constants.BASE_API_URL + "admin/volunteer/edit",
  // GET_CATEGORY_VOLUNTEER: Constants.BASE_API_URL + "admin/volunteer/view",
  // DELETE_CATEGORY_VOLUNTEER:
  //   Constants.BASE_API_URL + "admin/volunteer/category/delete",
  // ADD_CATEGORY_VOLUNTEER:
  //   Constants.BASE_API_URL + "admin/volunteer/category/add",

  // SUPPORT_LIST: Constants.BASE_API_URL + "admin/support/ticket/list",
  // ON_SEND_MESSAGE: Constants.BASE_API_URL + "user/support/send",
  // ON_READ_MESSAGE: Constants.BASE_API_URL + "admin/support/message/read",
  // VIEW_ADMIN_MESSAGELIST: Constants.BASE_API_URL + "user/support/ticket/view",

  // UPLOAD FILE
  UPLOAD_FILE: Constants.BASE_API_URL + "upload/file",
  UPLOAD:Constants.BASE_API_URL +"user/upload",
  ORGANISATION_LIST: Constants.BASE_API_URL + "organisation/list",
  ADD_IDS:Constants.BASE_API_URL + "admin/fixture/update/exported_ids",
  // master org admin
  ADMIN_MASTER_ORG_CREATE: Constants.BASE_API_URL + "admin/master-org/create",
  ADMIN_MASTER_ORG_UPDATE: Constants.BASE_API_URL + "admin/master-org/update",
  ADMIN_MASTER_ORG_LIST: Constants.BASE_API_URL + "admin/master-org/list",
  ADMIN_MASTER_ORG_DETAILS: Constants.BASE_API_URL + "admin/master-org/details",
  ADMIN_ORGS_ALL: Constants.BASE_API_URL + "admin/orgs/all",
  ADMIN_ORG_UPDATE: Constants.BASE_API_URL + "admin/org/update",
  // master org
  MASTER_ORG_CODES_CREATE:
    Constants.BASE_API_URL + "master-org/codes/create",
  MASTER_ORG_CODES_SEND_INVITE:
    Constants.BASE_API_URL + "master-org/codes/send-invite",
  MASTER_ORG_CODES_LIST: Constants.BASE_API_URL + "master-org/codes",
  MASTER_ORG_CODES_DELETE: Constants.BASE_API_URL + "master-org/codes/delete",
  MASTER_ORG_REQUESTS: Constants.BASE_API_URL + "master-org/requests",
  MASTER_ORG_REQUEST_APPROVE:
    Constants.BASE_API_URL + "master-org/request/approve",
  MASTER_ORG_REQUEST_DENY:
    Constants.BASE_API_URL + "master-org/request/deny",
  MASTER_ORG_ANALYTICS_DASHBOARD:
    Constants.BASE_API_URL + "master-org/analytics/dashboard",
  MASTER_ORG_SUB_ORGS: Constants.BASE_API_URL + "master-org/sub-orgs",
  MASTER_ORG_SUB_ORG_DETAILS: Constants.BASE_API_URL + "master-org/sub-org/",
  // Master org view of a connected club's content + analytics (path params)
  MASTER_ORG_SUB_ORG_CONTENT: (subOrgId) =>
    `${Constants.BASE_API_URL}master-org/sub-org/${subOrgId}/content`,
  MASTER_ORG_SUB_ORG_CONTENT_ANALYTICS: (subOrgId) =>
    `${Constants.BASE_API_URL}master-org/sub-org/${subOrgId}/analytics`,
  MASTER_ORG_SUB_ORG_CONTENT_ITEM_ANALYTICS: (subOrgId, idContent) =>
    `${Constants.BASE_API_URL}master-org/sub-org/${subOrgId}/content/${idContent}/analytics`,
  MASTER_ORG_SUB_ORG_UPDATE: Constants.BASE_API_URL + "master-org/sub-org/update",
  MASTER_ORG_SUB_ORG_DELETE: Constants.BASE_API_URL + "master-org/sub-org/delete",
  MASTER_ORG_USERS: Constants.BASE_API_URL + "master-org/users",
  MASTER_ORG_ACCOUNT_GET: Constants.BASE_API_URL + "master-org/account/get",
  MASTER_ORG_ACCOUNT_UPDATE:
    Constants.BASE_API_URL + "master-org/account/update",
  // Export endpoints
  ADMIN_USER_EXPORT: Constants.BASE_API_URL + "admin/user/export",
  MASTER_ORG_USER_EXPORT: Constants.BASE_API_URL + "master-org/users/export",
  ADMIN_ORG_EXPORT: Constants.BASE_API_URL + "admin/orgs/export",
  MASTER_ORG_SUB_ORG_EXPORT: Constants.BASE_API_URL + "master-org/sub-orgs/export",
  // Master org alerts (send to sub orgs)
  MASTER_ORG_ALERTS_SEND: Constants.BASE_API_URL + "master-org/alerts/send",
  // Master org alerts (send to specific sub-org members)
  MASTER_ORG_ALERTS_SEND_TO_USERS: Constants.BASE_API_URL + "master-org/alerts/send-to-users",
  MASTER_ORG_ALERTS_LIST: Constants.BASE_API_URL + "master-org/alerts/list",
  MASTER_ORG_ALERTS_DELETE: Constants.BASE_API_URL + "master-org/alerts/delete",
  // Master org advertisements
  MASTER_ORG_ADVERTISEMENT_LIST:   Constants.BASE_API_URL + "master-org/advertisement/list",
  MASTER_ORG_ADVERTISEMENT_VIEW:   Constants.BASE_API_URL + "master-org/advertisement/view",
  MASTER_ORG_ADVERTISEMENT_ADD:    Constants.BASE_API_URL + "master-org/advertisement/add",
  MASTER_ORG_ADVERTISEMENT_EDIT:   Constants.BASE_API_URL + "master-org/advertisement/edit",
  MASTER_ORG_ADVERTISEMENT_DELETE:    Constants.BASE_API_URL + "master-org/advertisement/delete",
  MASTER_ORG_ADVERTISEMENT_ANALYTICS: Constants.BASE_API_URL + "master-org/advertisement/analytics",
  // Admin alerts (send to users by user_ids)
  ADMIN_ALERTS_SEND: Constants.BASE_API_URL + "admin/alerts/send",
  // Admin alerts (send to sub-orgs by org_ids)
  ADMIN_ALERTS_SEND_TO_ORGS: Constants.BASE_API_URL + "admin/alerts/send-to-orgs",
  ADMIN_ALERTS_LIST: Constants.BASE_API_URL + "admin/alerts/list",
  ADMIN_ALERTS_DELETE: Constants.BASE_API_URL + "admin/alerts/delete",
  // Manual paid org + payments inbox
  ADMIN_ORG_ENABLE_PAID: Constants.BASE_API_URL + "admin/orgs/enable-paid",
  ADMIN_ORG_DISABLE_PAID: Constants.BASE_API_URL + "admin/orgs/disable-paid",
  ADMIN_PAYMENTS_INBOX: Constants.BASE_API_URL + "admin/payments/inbox",
  ADMIN_PAYMENTS_INBOX_READ: Constants.BASE_API_URL + "admin/payments/inbox/read",
};

export default endpoints;